import { Textarea } from "@ht/components";
import { useEffect } from "react";

const WidgetSample = () => {

    useEffect(() => {
        const script = document.createElement('script');

        script.src = String(process.env.REACT_APP_WIDGET_SAMPLE);
        script.setAttribute("service-group-id", String(process.env.REACT_APP_WIDGET_SAMPLE_SERVICE_GROUP));
        script.setAttribute("channel-application-id", String(process.env.REACT_APP_WIDGET_SAMPLE_CHANNEL_APPLICATION));
        script.setAttribute("tenant-id", String(process.env.REACT_APP_WIDGET_SAMPLE_TENANT));
        script.setAttribute("tag", "generic");
        script.async = true;

        const container = document.getElementById("widget-sample");
        container?.appendChild(script);

        return () => {
            container?.removeChild(script);
        }
    }, []);

    return (
        <div className="static">
            <div className="absolute bg-white h-full w-full" id="widget-sample">
                <Textarea id="test" name="test" className="w-full h-full" />
            </div>
        </div>
    );
};

export default WidgetSample;
